import { Injectable } from "@angular/core";
import { DajSveSifarnikeZaRecnikPojmovaResponse, SifarniciClient } from "app/api/iop-metaregistar-api-reference";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SifarniciStateService {
    constructor(private sifarniciClient: SifarniciClient) { }

    dajSveInterneSifarnike(): Observable<DajSveSifarnikeZaRecnikPojmovaResponse> {
        return this.sifarniciClient.dajSveSifarnikeZaRecnikPojmova(null);
    }
}